module.exports = __webpack_public_path__ + "img/european-spring-logo.60698b22.svg";